exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".change-line[data-v-8faf6cfc]{color:#F56C6C}.delete-line[data-v-8faf6cfc]{text-decoration:line-through}\n", ""]);

// exports
